import { BILL_CAPTURE, PARTNER_PROVIDED } from '~/funnels/resuming/config';
import { LDClient } from '~/providers/launch-darkly';
import { LDFlags } from '~/providers/launch-darkly/flags';
import { UtilityConnectStatus } from '~/typings/utility-connect';
import { communitySolarFunnelRedirects } from '~/utils/redirects';
import { PerchEnergyContext, PerchEnergyParams } from './types';

export const uploadContextOverrides = (
  funnelContext: PerchEnergyContext,
  params?: PerchEnergyParams,
) => {
  return {
    funnelId: params?.id,
    promoCode:
      funnelContext.queryParams?.promoCode ||
      funnelContext.queryParams?.unparsedQueryParams?.promoCode,
    funnelPacket: funnelContext.funnelPacket!,
    ...params?.upload?.context,
  };
};

export const userContextOverrides = (
  funnelContext: PerchEnergyContext,
  params?: PerchEnergyParams,
) => {
  return {
    funnelId: params?.id,
    queryParams: funnelContext.queryParams,
    utility: funnelContext.utilitySelection!,
    zipCode: funnelContext.zipCode!,
    funnelVnmProjectId:
      funnelContext.funnelVnmProjectId! ||
      LDClient.variation(LDFlags.ffDefaultSignupProjectId)?.project_id,
    promoCode:
      funnelContext.queryParams?.promoCode ||
      funnelContext.queryParams?.unparsedQueryParams?.promoCode,
    ...params?.user?.context,
  };
};

export const enrollmentContextOverrides = (
  funnelContext: PerchEnergyContext,
  params?: PerchEnergyParams,
) => {
  return {
    funnelPacket: funnelContext.funnelPacket!,
    funnelId: params?.id,
    enrollmentOptions: funnelContext.enrollmentOptions,
    showUtilityConnectButton: funnelContext?.enrollmentOptions?.includes('utility_connect'),
    startAtAccountNumber:
      funnelContext.queryParams?.enrollmentOption === PARTNER_PROVIDED ||
      LDClient.variation(LDFlags.showUtiltityAccountNumberScreen),
    startAtBillUpload: funnelContext.queryParams?.enrollmentOption === BILL_CAPTURE,
    promoCode:
      funnelContext.queryParams?.promoCode ||
      funnelContext.queryParams?.unparsedQueryParams?.promoCode,
    queryParams: funnelContext.queryParams,
    unparsedQueryParams: funnelContext.queryParams?.unparsedQueryParams,
    utmParams: funnelContext.queryParams?.utmParams,
    advanceOn: ['verified', 'timed_out'] as UtilityConnectStatus[],
    ...params?.enrollment?.context,
  };
};
export const utilityContextOverrides = (
  funnelContext: PerchEnergyContext,
  params?: PerchEnergyParams,
) => {
  return {
    queryParams: funnelContext.queryParams,
    redirect: communitySolarFunnelRedirects,
    resuming: funnelContext.queryParams.resumingUser,
    funnelId: params?.id,
    ...params?.utility?.context,
  };
};
